<template>
  <Row id="AnnualLeavePlan">
    <Col :span="24" class="title">
      <TypographyTitle>{{$t('nav.name.AnnualLeavePlanManage')}}</TypographyTitle>
    </Col>
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('annualLeavePlan.name.search')" name="search">
                  <Input :placeholder="$t('annualLeavePlan.name.search')" v-model:value="searchForm.search"></Input>
                </FormItem>
              </Col>
              <!-- <Col :xs="24" :sm="8">
                <FormItem :label="$t('public.field.status')">
                  <Select v-model:value="searchForm.status" :placeholder="$t('public.placeholder.please_select')">
                    <SelectOption :value="0">{{ $t('public.placeholder.please_select') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('public.status.1') }}</SelectOption>
                    <SelectOption :value="2">{{ $t('public.status.2') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col> -->
              <Col :xs="24" :sm="8" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24">
        <Table :columns="columns" :dataSource="list" :scroll="{ x: true }" rowKey="idAnnLeaPla" :loading="loading" :pagination="tablePagination" @change="chang_page">
            <template #actionTitle>
              <span>
                {{$t("public.table.action")}}
                <Button v-if="checkPermission('AnnualLeavePlanManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button>
              </span>
            </template>
            <template #action="{text}">
              <div>
                <!-- <div class="pc-display">
                  <Button type="default" size="small" @click="detail(text)">{{$t("public.name.detail")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('AnnualLeavePlanManage.Edit')" type="primary" size="small" @click="edit(text)">{{$t("public.name.edit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('AnnualLeavePlanManage.Delete')" type="primary" danger size="small" @click="del(text.idAnnLeaPla)">{{$t("public.name.del")}}</Button>
                </div> -->
                <Dropdown :trigger="['click']">
                  <template #overlay>
                    <Menu>
                      <MenuItem @click="detail(text)">{{$t("public.name.detail")}}</MenuItem>
                      <MenuItem v-if="checkPermission('AnnualLeavePlanManage.Edit')" @click="edit(text)">{{$t("public.name.edit")}}</MenuItem>
                      <MenuItem v-if="checkPermission('AnnualLeavePlanManage.Delete')" danger @click="del(text.idAnnLeaPla)">{{$t("public.name.del")}}</MenuItem>
                    </Menu>
                  </template>
                  <Button size="small">
                    {{$t("public.name.more")}}
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </template>
          </Table>
        </Col>
      </Row>
    </Col>
    <AnnualLeavePlanDetail ref="refAnnualLeavePlanDetail"></AnnualLeavePlanDetail>
    <AnnualLeavePlanEdit ref="refAnnualLeavePlanEdit" @updateList="get_list"></AnnualLeavePlanEdit>
  </Row>
</template>

<script>
import { createVNode } from "vue";
import { Row, Col, Table, Typography, Tag, Button, Dropdown, Menu, Modal, Form, Input, Select, message } from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { AnnualLeavePlanList } from "@/api/AnnualLeavePlanList";
import { AnnualLeavePlanDelete } from "@/api/AnnualLeavePlanDelete"
import AnnualLeavePlanDetail from "@/components/Home/AnnualLeavePlanDetail";
import AnnualLeavePlanEdit from "@/components/Home/AnnualLeavePlanEdit";

export default {
  name: "AnnualLeavePlanManage",
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    TypographyTitle: Typography.Title,
    Tag,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    Dropdown,
    DownOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Menu,
    MenuItem: Menu.Item,
    AnnualLeavePlanDetail,
    AnnualLeavePlanEdit,
  },
  data() {
    return {
      searchForm: {
      },
      tablePagination: {
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      list: [],
      columns: [
          { title: this.$t("annualLeavePlan.table.id_ann_lea_pla"), fixed: "left", dataIndex: "idAnnLeaPla", key: "idAnnLeaPla" },
          { title: this.$t("annualLeavePlan.table.plan_name"),  dataIndex: "planName", key: "planName" },
          { title: this.$t("annualLeavePlan.table.annual_leave_days"),  dataIndex: "annualLeaveDays", key: "annualLeaveDays", customRender: ({text,record}) =>{
              return text + '天'
            }
           },
          // { title: this.$t("annualLeavePlan.table.maternity_leave_days"),  dataIndex: "maternityLeaveDays", key: "maternityLeaveDays" },
          // { title: this.$t("annualLeavePlan.table.paternity_leave_days"),  dataIndex: "paternityLeaveDays", key: "paternityLeaveDays" },
          { title: this.$t("annualLeavePlan.table.annual_leave_days_year_imcrement"), dataIndex: "annualLeaveDaysYearImcrement", key: "annualLeaveDaysYearImcrement", customRender: ({text,record}) =>{
              return text + '天'
            } },
	  { title: this.$t("annualLeavePlan.table.max_annual_leave_days"), dataIndex: "maxAnnualLeaveDays", key: "maxAnnualLeaveDays", customRender: ({text,record}) =>{
              return text + '天'
            } },
        { key: "action", fixed: "right", slots: { title: "actionTitle", customRender: "action" } },
      ],
      selectList:{
      }
    };
  },
  methods: {
    chang_page(pagination) {
      this.tablePagination = pagination;
      this.get_list();
    },
    get_list() {
      this.loading = true;
      const api = new AnnualLeavePlanList();
      const getData = {
        page: this.tablePagination.current,
        limit: this.tablePagination.pageSize,
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      // if (this.searchForm.status != 0) getData.status = this.searchForm.status
      // if (this.searchForm.order != "") getData.order = this.searchForm.order
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data.data;
            this.tablePagination.current = parseInt(dataTmp.current);
            this.tablePagination.pageSize = parseInt(dataTmp.pageSize);
            this.tablePagination.total = parseInt(dataTmp.total);
            this.list = dataTmp.data;
            //如果當前處於不是第一頁，但是又沒有數據的情況，則把頁面設置為1，並重新請求
            if(this.list.length == 0 && this.tablePagination.current != 1){
              this.tablePagination.current = 1;
              this.get_list();
            }
          } else {
            this.list = [];
          }
        });
    },
    add() {
      this.$refs.refAnnualLeavePlanEdit.addShow();
    },
    detail(obj) {
      this.$refs.refAnnualLeavePlanDetail.detailShow(obj);
    },
    edit(obj) {
      this.$refs.refAnnualLeavePlanEdit.editShow(obj);
    },
    del(idAnnLeaPla) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_delete") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new AnnualLeavePlanDelete();
          api.post({ idAnnLeaPla: idAnnLeaPla }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    search_submit() {
      this.get_list()
    },
    search_reset() {
      this.searchForm = {
        // search: "",
        // status: 0,
        // order: "",
      }
      this.get_list()
    }
  },
  mounted() {
    this.get_list();
  },
}
</script>

<style lang="less">
@import url("~@/assets/less/home/annualLeavePlan.less");
</style>